
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { UserProfile } from '../types';

interface AuthContextType {
    user: UserProfile | null;
    login: (email: string, password: string) => Promise<boolean>;
    logout: () => void;
    isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<UserProfile | null>(null);

    useEffect(() => {
        // Hydrate from localStorage
        const storedUser = localStorage.getItem('arsenal_user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    const login = async (email: string, password: string): Promise<boolean> => {
        // Mock authentication
        if (email === 'admin@arsenal.com' && password === 'arsenal') {
            const mockUser: UserProfile = {
                id: 1,
                name: 'Rodrigo Ribeiro',
                email: 'admin@arsenal.com',
                crNumber: 'CR-123456',
                cacLevel: 'Atirador Desportivo - Nível III',
                memberSince: '2023',
                location: 'São Paulo, SP',
                role: 'Administrador',
                avatarInitial: 'R',
                stats: {
                    activeListings: 12,
                    sales: 45,
                    reviews: 128,
                    views: 12500
                },
                crStatus: 'Verificado'
            };
            setUser(mockUser);
            localStorage.setItem('arsenal_user', JSON.stringify(mockUser));
            return true;
        }
        return false;
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('arsenal_user');
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, isAuthenticated: !!user }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
